import { render, staticRenderFns } from "./pccxy.vue?vue&type=template&id=071e0ab6&scoped=true&"
import script from "./pccxy.vue?vue&type=script&lang=js&"
export * from "./pccxy.vue?vue&type=script&lang=js&"
import style0 from "./pccxy.vue?vue&type=style&index=0&id=071e0ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e0ab6",
  null
  
)

export default component.exports